// import React, { useState } from 'react'
// import '../Pages/CSS/LoginSignup.css'
// import BASE_URL from '../Config/api.js';
// const LoginSignup = () => {
//   const [state, setState] = useState("Login");
//   const[formData,setFormData] = useState({
//     username:"",
//     password:"",
//     email:""
//   })
//   const login = async()=>{
//        let responseData;
//     await fetch(`${BASE_URL}/login`,{
//       method:'POST',
//       headers:{
//         Accept:'application/form-data',
//         'Content-Type':'application/json'
//       },
//       body:JSON.stringify(formData)
//     }).then((response)=>response.json()).then((data)=>responseData=data)
//      if(responseData.success){
//       localStorage.setItem('auth-token',responseData.token);
//       window.location.replace("/")
//     }
//     else{
//       alert(responseData.error)
//     }
//   }
//    const signup = async()=>{
//     console.log(formData);
//     let responseData;
//     await fetch(`${BASE_URL}/signup`,{
//       method:'POST',
//       headers:{
//         Accept:'application/form-data',
//         'Content-Type':'application/json'
//       },
//       body:JSON.stringify(formData)
//     }).then((response)=>response.json()).then((data)=>responseData=data)
//      if(responseData.success){
//       localStorage.setItem('auth-token',responseData.token);
//       window.location.replace("/")
//     }
//     else{
//       alert(responseData.error)
//     }
//   }

//   const changeHandler = (e)=>{
//     setFormData({...formData,[e.target.name]:e.target.value})
   
//   }
//   return (
//     <div className='loginsignup'>
//       <div className="loginsignup-container">
//         <h1>{state}</h1>
//         <div className="loginsignup-fields">
//           {state==="Sign Up"?<input type="text" name='username' value={formData.username} onChange={changeHandler} placeholder='your name' />:<></>}
//           <input name='email' value={formData.email} type="email" onChange={changeHandler} placeholder='Email Address' />
//           <input name='password' value={formData.password} onChange={changeHandler} type="password" placeholder='password' />
//         </div>
//         <button onClick={()=>{state==="Login"?login():signup()}}>Continue</button>
//         {state==="Sign Up"?<p className='loginsignup-login' onClick={()=>{setState("Login")}}> Already have an account ? <span>Login here</span></p>:<p className='loginsignup-login'> Create An Account ? <span onClick={()=>{setState("Sign Up")}}>Sign Up Here</span></p>}
        
        
//         <div className="loginsignup-agree">
//           <input type="checkbox" name=' ' id='' />
//           <p>By continue, i agree to the terms of use & privacy policy</p>
//         </div>
//       </div>
//     </div>
//   ) 
// }

// export default LoginSignup
import React, { useState } from "react";
import "../Pages/CSS/LoginSignup.css";
import BASE_URL from "../Config/api.js";

const LoginSignup = () => {
  const [state, setState] = useState("Login");
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
  });

  const login = async () => {
    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem("auth-token", data.token);
        window.location.replace("/");
      } else {
        alert(data.error);
      }
    } catch (err) {
      console.error("Login error:", err);
      alert("Something went wrong, try again!");
    }
  };

  const signup = async () => {
    try {
      const response = await fetch(`${BASE_URL}/signup`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem("auth-token", data.token);
        window.location.replace("/");
      } else {
        alert(data.error);
      }
    } catch (err) {
      console.error("Signup error:", err);
      alert("Something went wrong, try again!");
    }
  };

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="loginsignup">
      <div className="loginsignup-container">
        <h1>{state}</h1>
        <div className="loginsignup-fields">
          {state === "Sign Up" && (
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={changeHandler}
              placeholder="Your Name"
            />
          )}
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={changeHandler}
            placeholder="Email Address"
          />
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={changeHandler}
            placeholder="Password"
          />
        </div>
        <button onClick={() => (state === "Login" ? login() : signup())}>
          Continue
        </button>

        <p className="loginsignup-toggle">
          {state === "Sign Up" ? (
            <>
              Already have an account?{" "}
              <span onClick={() => setState("Login")}>Login here</span>
            </>
          ) : (
            <>
              Create an account?{" "}
              <span onClick={() => setState("Sign Up")}>Sign Up here</span>
            </>
          )}
        </p>
{/* 
        <div className="loginsignup-agree">
          <input type="checkbox" id="agree" />
          <label htmlFor="agree">
            By continuing, I agree to the <b>Terms of Use</b> &{" "}
            <b>Privacy Policy</b>
          </label>
        </div> */}
      </div>
    </div>
  );
};

export default LoginSignup;
